var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 14.1667H4.66665C2.23331 14.1667 0.833313 12.7667 0.833313 10.3334V5.66671C0.833313 3.23337 2.23331 1.83337 4.66665 1.83337H11.3333C13.7666 1.83337 15.1666 3.23337 15.1666 5.66671V10.3334C15.1666 12.7667 13.7666 14.1667 11.3333 14.1667ZM4.66665 2.83337C2.75998 2.83337 1.83331 3.76004 1.83331 5.66671V10.3334C1.83331 12.24 2.75998 13.1667 4.66665 13.1667H11.3333C13.24 13.1667 14.1666 12.24 14.1666 10.3334V5.66671C14.1666 3.76004 13.24 2.83337 11.3333 2.83337H4.66665Z",
    fill: "#0A8A95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99987 8.57998C7.43987 8.57998 6.87321 8.40665 6.43987 8.05331L4.3532 6.38665C4.13987 6.21331 4.09987 5.89998 4.27321 5.68665C4.44654 5.47331 4.75988 5.43332 4.97321 5.60665L7.05987 7.27332C7.56654 7.67998 8.42654 7.67998 8.9332 7.27332L11.0199 5.60665C11.2332 5.43332 11.5532 5.46665 11.7199 5.68665C11.8932 5.89998 11.8599 6.21998 11.6399 6.38665L9.55321 8.05331C9.12654 8.40665 8.55987 8.57998 7.99987 8.57998Z",
    fill: "#0A8A95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6299ba684d8056602ef782dc281ce08e.svg";
export { ForwardRef as ReactComponent };